module.exports = __webpack_public_path__ + "static/img/yf_01.7aaecc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yf/yf_01.jpg
// module id = 9EGL
// module chunks = 1